import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/gold-logo-transparent.png'


const _hoisted_1 = { class: "fixed w-full z-50" }
const _hoisted_2 = {
  class: "flex items-center justify-between p-6 lg:px-8 backdrop-blur-md",
  "aria-label": "Global"
}
const _hoisted_3 = { class: "flex lg:hidden" }
const _hoisted_4 = { class: "hidden lg:flex lg:gap-x-12" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "hidden lg:flex lg:flex-1 lg:justify-end" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  class: "lg:hidden h-full fixed top-16 inset-y-0 right-0 z-50 w-full overflow-y-auto bg-[#151515] px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
}
const _hoisted_9 = { class: "mt-6 flow-root" }
const _hoisted_10 = { class: "-my-6 divide-y divide-gray-500/10" }
const _hoisted_11 = { class: "space-y-2" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]

import { computed, ref } from 'vue';
import * as amplitude from '@amplitude/analytics-browser';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const mobileMenuOpen = ref(false);

const navigation = [
  { name: 'Services', href: '/#services' },
  { name: 'How it works', href: '/#howitworks' },
  { name: 'Partners', href: '/#partners' },
  { name: 'Reviews', href: '/#reviews' },
  { name: 'Key features', href: '/#features' },
  { name: 'Blog', href: '/blog' },
];
function onDownloadBtnClick() {
  amplitude.track('download_btn_click');
}

const isAndroid = computed(() => /Android/i.test(navigator.userAgent));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex lg:flex-1" }, [
        _createElementVNode("a", {
          href: "/",
          class: "-m-1.5 p-1.5"
        }, [
          _createElementVNode("span", { class: "sr-only" }, "TALAB"),
          _createElementVNode("img", {
            class: "h-5 w-auto",
            src: _imports_0,
            alt: ""
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (mobileMenuOpen.value = !mobileMenuOpen.value))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "sr-only" }, "Open main menu", -1),
          _createElementVNode("svg", {
            class: "w-5 h-5",
            "aria-hidden": "true",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 17 14"
          }, [
            _createElementVNode("path", {
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M1 1h15M1 7h15M1 13h15"
            })
          ], -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
          return _createElementVNode("a", {
            key: item.name,
            href: item.href,
            class: "text-sm font-semibold leading-6 text-gray-900"
          }, _toDisplayString(item.name), 9, _hoisted_5)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          href: 
            isAndroid.value
              ? 'https://play.google.com/store/apps/details?id=com.talabapp.talab&hl=en_GB'
              : 'https://apps.apple.com/us/app/talab-ultimate-student-app/id6503147995'
          ,
          onClick: onDownloadBtnClick,
          class: "text-sm font-semibold leading-6 text-gray-900"
        }, _cache[3] || (_cache[3] = [
          _createTextVNode("Download "),
          _createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
        ]), 8, _hoisted_7)
      ])
    ]),
    _createVNode(_Transition, { name: "menu-slide" }, {
      default: _withCtx(() => [
        (mobileMenuOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                      return _createElementVNode("a", {
                        key: item.name,
                        href: item.href,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileMenuOpen.value = false)),
                        class: "-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white"
                      }, _toDisplayString(item.name), 9, _hoisted_12)
                    }), 64)),
                    _createElementVNode("a", {
                      href: 
                  isAndroid.value
                    ? 'https://play.google.com/store/apps/details?id=com.talabapp.talab&hl=en_GB'
                    : 'https://apps.apple.com/us/app/talab-ultimate-student-app/id6503147995'
                ,
                      onClick: onDownloadBtnClick,
                      class: "text-base font-semibold leading-6 text-white mt-16 py-2 px-3 -mx-3 block"
                    }, _cache[5] || (_cache[5] = [
                      _createTextVNode("Download "),
                      _createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
                    ]), 8, _hoisted_13)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})